import DOMPurify from 'dompurify';

// Sanitize HTML content produced by the WYSIWYG editor before rendering.
// Allows a modest set of formatting tags used by React Quill.
export function sanitizeHtml(dirty) {
    if (!dirty) return '';
    try {
        return DOMPurify.sanitize(String(dirty), {
            ALLOWED_TAGS: [
                'p', 'br', 'hr', 'strong', 'b', 'em', 'i', 'u', 's', 'sub', 'sup',
                'blockquote', 'pre', 'code',
                'a', 'span',
                'ul', 'ol', 'li',
                'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
                'img', 'figure',
                'table', 'thead', 'tbody', 'tr', 'td', 'th',
            ],
            ALLOWED_ATTR: ['href', 'title', 'target', 'rel', 'src', 'alt', 'class', 'style'],
            ALLOW_DATA_ATTR: false,
        });
    } catch (_) {
        return '';
    }
}

// Convert HTML to plain text for use in card snippets, meta descriptions, etc.
export function htmlToPlainText(html, maxLen = 200) {
    if (!html) return '';
    try {
        const el = document.createElement('div');
        el.innerHTML = String(html);
        const txt = (el.textContent || el.innerText || '').replace(/\s+/g, ' ').trim();
        return maxLen && txt.length > maxLen ? txt.slice(0, maxLen).trimEnd() + '…' : txt;
    } catch (_) {
        // SSR / non-DOM fallback: regex strip
        const txt = String(html).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        return maxLen && txt.length > maxLen ? txt.slice(0, maxLen).trimEnd() + '…' : txt;
    }
}

export function isHtmlEmpty(html) {
    if (!html) return true;
    const t = htmlToPlainText(html, 0);
    return !t;
}
